module.exports = __webpack_public_path__ + "images/4af1f8966b1f3939b75e2b61c3c37910-MSW_LineArt_Numbers(1)_slide19.png";